import React from 'react';

import styles from './styles.module.scss';
import BlockComponent from '../block';

export default props => {
    const blocks = props.blockIds.map(id => <BlockComponent key={`athlete-history-block-${id}`} id={id} />);

    if (props.expanded) {
        var carrot = (<div><img src="https://assets.reponestrength.com/carrot_down.png" alt="Collapse session" loading="lazy" /></div>);
        var onClick = () => props.collapse(props.id);
    } else {
        var carrot = (<div><img src="https://assets.reponestrength.com/carrot_right.png" alt="Expand session" loading="lazy" /></div>);
        var onClick = () => props.expand(props.id, props.athleteId);
    }

    return (
        <div>
            <div className={styles.container} onClick={onClick}>
                {carrot}
                <div>Session {props.displayNumber}</div>
                <div>{props.summary}</div>
                <div>{props.date}</div>
            </div>
            {blocks}
        </div>
    );
};
